export default __webpack_public_path__ + "c7550f8507141b8372c247d623ba0b64.svg";